<template>
  <div class="site-calendar">
    <div class="d-flex flex-column align-center">
      <div
        style="width: 100%;"
      >
        <VDatePicker
          v-model="selectedDate"
          :outlined="false"
          prependInnerIcon="mdi-calendar"
          hideDetails
        />
      </div>
      <div class="d-flex align-center">
        <!-- Bouton pour aller à la semaine précédente -->
        <v-btn
          icon
          @click="previousWeek"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <!-- Affichage des 7 jours sous forme de vignettes -->
        <div class="d-flex justify-center">
          <v-btn
            v-for="(day, index) in weekDays"
            :key="index"
            :class="{'selected-day': isSelected(day)}"
            style="width: 10px;"
            :color="selectedDate === day.actualDate ? 'primary' : ''"
            @click="selectDate(day)"
          >
            {{ day.date }}
            <div>
              <div>
                {{ day.dateObj.weekday }}
              </div>
              <div>
                <div
                  style="height: 15px; font-size: 2rem; display: flex; align-items: center;justify-content: center;"
                >
                  {{ isDateInAppointments(day.dateObj.day) ? '•' : '' }}
                </div>
              </div>
              <div>
                {{ day.dateObj.day }}
              </div>
            </div>
          </v-btn>
        </div>

        <!-- Bouton pour aller à la semaine suivante -->
        <v-btn
          icon
          @click="nextWeek"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div
      style="width: 100%"
    >
      <ThumbnailAppointment
        v-for="(appointment, index) in paginatedAppointments"
        :key="index"
        :appointment="appointment.calendarInfo"
        :selectedDay="selectedDate.slice(-2)"
        :jobName="appointment.jobName"
      />
    </div>
    <v-pagination
      v-if="lengthByDay(Number(selectedDate.slice(-2))) > itemsPerPage"
      v-model="currentPage"
      :length="totalPages"
      rounded="circle"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker';
import ThumbnailAppointment from './ThumbnailAppointment.vue';

export default {
    name: 'Calendar',

    components: {
        VDatePicker,
        ThumbnailAppointment,
    },
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedDate: this.formatDate(new Date()), // Date du jour au format YYYY-MM-DD
            menu: false,

            appointments: [],
            // Datas pour la pagination
            currentPage: 1,
            itemsPerPage: 4,
        };
    },

    computed: {
        ...mapGetters([
            'lang',
            'site',
        ]),

        weekDays() {
            const startOfWeek = this.getStartOfWeek(new Date(this.selectedDate));
            const week = [];

            for (let i = 0; i < 7; i += 1) {
                const day = new Date(startOfWeek);
                day.setDate(startOfWeek.getDate() + i);
                week.push({
                    displayDate: day.toLocaleDateString(this.lang, {
                        weekday: 'short', day: 'numeric', month: 'short',
                    }),
                    actualDate: this.formatDate(day),
                    dateObj: {
                        weekday: day.toLocaleDateString(this.lang, {
                            weekday: 'short',
                        }).substring(0, 2),
                        day: day.getDate(),
                        month: day.toLocaleDateString(this.lang, {
                            month: 'short',
                        }),
                    },
                });
            }
            return week;
        },
        weekRange() {
            const startOfWeek = this.getStartOfWeek(new Date(this.selectedDate));
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);

            return {
                start: startOfWeek,
                end: endOfWeek,
            };
        },
        totalPages() {
            const length = this.lengthByDay(Number(this.selectedDate.slice(-2)));
            return Math.ceil(length / this.itemsPerPage);
        },
        paginatedAppointments() {
            const filtered = this.appointments.filter(
                app => app.calendarInfo.schedule.dayOfMonth[0] === Number(this.selectedDate.slice(-2)),
            );
            const start = (this.currentPage - 1) * this.itemsPerPage;
            return filtered.slice(start, start + this.itemsPerPage);
        },
    },

    watch: {

    },

    created() {
        this.getAppointments();
    },

    methods: {

        async getAppointments() {
            const { data } = await this.$rq.getAppointmentsBySite(this.site.id, this.weekRange.start, this.weekRange.end);
            this.appointments = data;
        },
        isDateInAppointments(day) {
            return this.appointments.some(app => app.calendarInfo.schedule.dayOfMonth[0] === day);
        },
        lengthByDay(day) {
            return this.appointments.filter(app => app.calendarInfo.schedule.dayOfMonth[0] === day).length;
        },

        // Format YYYY-MM-DD pour v-date-picker
        formatDate(date) {
            const year = date.getFullYear();
            const month = (`0${ date.getMonth() + 1}`).slice(-2);
            const day = (`0${ date.getDate()}`).slice(-2);
            return `${year}-${month}-${day}`;
        },

        // Trouver le début de la semaine (lundi)
        getStartOfWeek(date) {
            const day = date.getDay();
            const diff = date.getDate() - day + 1;
            const startOfWeek = new Date(date.setDate(diff));
            startOfWeek.setHours(0, 0, 0, 0);
            return startOfWeek;
        },

        // Aller à la semaine précédente
        previousWeek() {
            const date = new Date(this.selectedDate);
            date.setDate(date.getDate() - 8);
            this.selectedDate = this.formatDate(date);
            this.getAppointments();
        },

        // Aller à la semaine suivante
        nextWeek() {
            const date = new Date(this.selectedDate);
            date.setDate(date.getDate() + 8);
            this.selectedDate = this.formatDate(date);
            this.getAppointments();
        },

        // Sélectionner une date spécifique
        selectDate(day) {
            this.selectedDate = day.actualDate;
        },

        // Vérifier si un jour est sélectionné
        isSelected(day) {
            return this.selectedDate === day.actualDate;
        },

    },
};
</script>

<style lang="scss" scoped>
.site-calendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #FFF;
    border-radius: 7px;
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 6px;
        background: #DEDEDE;
        border-radius: 7px 7px 0px 0px;
    }

    h3 {
        display: flex;
        justify-content: center;

        width: 100%;

        font-size: 16px;
        font-weight: 400;
        text-transform: capitalize;
        text-align: center;
    }

    .redirect-icon {
        display: flex;
        width: 16px;
        height: 16px;
    }

    .calendar {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        width: 100%;
        padding: 5px;
    }

    .appointments {
        width: 80%;
        margin: auto;
        max-height: 200px;

        overflow: auto;
    }

    .no-appointments {
        padding: 20px;

        color: rgba(20, 20, 20, 0.25);

        font-size: 12px;
        text-align: center;
    }

    /* ---- Scrollbars ---- */
    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
    }

    ::-webkit-scrollbar-thumb {
        background: rgba(18, 18, 18, 0.25);
        border-radius: 8px;
    }

}
</style>
<style lang="scss">
.site-calendar {
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 40px;
    height: 70px;
  }
  .v-btn--contained {
    box-shadow: none !important;
  }
  // J'enleve la bordure autour du input
  fieldset {
    border: none !important;
  }

}
</style>
